<template>
  <VueFlip
    class="flip-card"
    :value="value"
    @input="$emit('input', $event)"
    :width="width"
    :height="height"
    :style="styles"
    ref="flipCard"
  >
    <template v-slot:front>
      <v-card class="front__card" :width="width" :color="color" elevation="5" @click.stop="$emit('click', $event)">
        <v-list-item class="flip-card__title" one-line>
          <v-list-item-avatar v-if="icon">
            <v-icon :color="iconColor">{{ icon }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="d-flex text-h5">
              <template v-if="to">
                <a class="title-text title-link text-truncate flex-shrink-1" @click.stop="$router.push(to)">{{
                  title
                }}</a>
              </template>
              <template v-else>
                <span class="title-text text-truncate flex-shrink-1">{{ title }}</span>
              </template>
              <v-icon :small="rightIconSmall" v-if="!!rightIcon" :color="rightIconColor" right>{{ rightIcon }}</v-icon>
            </v-list-item-title>
            <!-- <v-list-item-subtitle>configured asset subtitle goes here (User story 6057)</v-list-item-subtitle>
            -- also make sure to change the v-list-item attribute from "one-line" to "two-line" and to bump the card
            height in WatchCard.vue to '260px' when uncommenting this-->
          </v-list-item-content>
          <v-list-item-action v-if="$slots.frontAction">
            <slot name="frontAction"></slot>
          </v-list-item-action>
        </v-list-item>
        <v-card-text v-if="$slots.front" :class="frontCardTextClass">
          <slot name="front"></slot>
        </v-card-text>
      </v-card>
    </template>
    <template v-slot:back>
      <v-card class="back__card" :width="width" elevation="5" @click.stop="$emit('click', $event)">
        <v-list-item class="flip-card__title" one-line>
          <v-list-item-avatar v-if="icon">
            <v-icon :color="iconColor">{{ icon }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="d-flex">
              <template v-if="to">
                <a class="title-text title-link text-truncate flex-shrink-1" @click.stop="$router.push(to)">{{
                  title
                }}</a>
              </template>
              <template v-else>
                <span class="title-text text-truncate flex-shrink-1">{{ title }}</span>
              </template>
              <v-icon :small="rightIconSmall" v-if="!!rightIcon" :color="rightIconColor" right>{{ rightIcon }}</v-icon>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="$slots.backAction">
            <slot name="backAction"></slot>
          </v-list-item-action>
        </v-list-item>
        <v-card-text v-if="$slots.back" :class="backCardTextClass">
          <slot name="back"></slot>
        </v-card-text>
      </v-card>
    </template>
  </VueFlip>
</template>
<script>
import VueFlip from 'vue-flip'

export default {
  name: 'FlipCard',
  components: {
    VueFlip
  },
  props: {
    value: {
      type: Boolean,
      description: 'Flipped value',
      default: false
    },
    title: {
      type: String,
      description: 'Card label',
      default: ''
    },
    icon: {
      type: String,
      description: 'Icon name',
      default: null
    },
    iconColor: {
      type: String,
      description: 'Icon color',
      default: 'white'
    },
    rightIcon: {
      type: String,
      description: 'Right icon name'
    },
    rightIconColor: {
      type: String,
      description: 'Right icon color'
    },
    rightIconSmall: {
      type: Boolean
    },
    color: {
      type: String,
      description: 'Background color',
      default: 'white'
    },
    font: {
      type: String,
      description: 'Font color',
      default: 'black'
    },
    backColor: {
      type: String,
      description: 'Background color',
      default: 'white'
    },
    backFont: {
      type: String,
      description: 'Font color',
      default: 'black'
    },
    backIconColor: {
      type: String,
      description: 'Icon color',
      default: 'black'
    },
    width: {
      type: String,
      description: 'Width',
      default: '100%'
    },
    height: {
      type: String,
      description: 'Height',
      default: '250px'
    },
    frontCardTextClass: {
      type: String,
      description: 'Class for front card text area',
      default: 'justify-center align-center text-center'
    },
    backCardTextClass: {
      type: String,
      description: 'Class for back card text area',
      default: 'backText pt-0'
    },
    to: {
      type: String,
      description: 'Title link',
      default: null
    },
    topColor: {
      type: String,
      description: 'Color of top bar',
      default: '#7bc3ec'
    }
  },
  watch: {
    topColor: {
      handler: function (val) {
        this.$nextTick(() => {
          if (!this.$refs.flipCard || !this.$refs.flipCard.$el) return

          let front = this.$refs.flipCard.$el.querySelector('.front')
          if (front) front.style.borderTopColor = val

          let back = this.$refs.flipCard.$el.querySelector('.back')
          if (back) back.style.borderTopColor = val
        })
      },
      immediate: true
    }
  },
  computed: {
    styles() {
      return `height: ${this.height}`
    }
  }
}
</script>

<style lang="scss" scoped>
$flip-card-title-height: 56px;

.v-card--link:focus::before {
  //Remove the grey shading after the card is clicked and the ripple
  //animation finishes.
  opacity: 0;
}

.flip-card {
  width: 100% !important;
}

.flip-card__title {
  height: $flip-card-title-height;
}

::v-deep .front {
  width: 100%;
  height: 100% !important;
  border-top-width: 10px;
  border-top-style: solid;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

::v-deep .back {
  width: 100%;
  height: 100% !important;
  border-top-width: 10px;
  border-top-style: solid;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}

.backText {
  height: calc(100% - $flip-card-title-height) !important;
  overflow-y: auto !important;
}

.front__card,
.back__card {
  position: fixed !important;
  height: 100%;
}

.title-link {
  text-decoration: underline !important;
}
</style>
